import React, { FC } from 'react'

import { DecorationTitle, StandardButton } from 'src/components/atoms'

import { useAuthority } from 'src/hooks'

type Props = {
  isEditMode?: boolean
  editButtonId: string
  cancelButtonId: string
  isLoading?: boolean
  onClickEdit?: () => void
  onClickCancel?: () => void
  className?: string
}

export const AssignProjectListTopTitle: FC<Props> = ({
  isEditMode,
  editButtonId,
  cancelButtonId,
  isLoading,
  onClickEdit,
  onClickCancel,
  className,
}) => {
  const { canAssignProject } = useAuthority()

  return (
    <div className={className}>
      <div className="tw-full-justify">
        <div className="tw-flex tw-items-center">
          <DecorationTitle>アサインプロジェクト</DecorationTitle>
        </div>

        {canAssignProject &&
          (isEditMode ? (
            <div className="tw-flex">
              <StandardButton
                id={cancelButtonId}
                size="s"
                buttonType="secondary"
                text="キャンセル"
                appendIconPath="close/soft/line"
                isLoading={isLoading}
                onClick={onClickCancel}
              />
              <StandardButton
                size="s"
                text="決定"
                appendIconPath="check/soft/line"
                type="submit"
                isLoading={isLoading}
                className="tw-ml-s1"
              />
            </div>
          ) : (
            <StandardButton
              id={editButtonId}
              size="s"
              buttonType="secondary"
              text="編集"
              appendIconPath="settings/soft/line"
              onClick={onClickEdit}
            />
          ))}
      </div>
    </div>
  )
}
